import { Injectable, ViewChild, ElementRef, OnDestroy } from "@angular/core";
import { Observable, BehaviorSubject, Subject, throwError } from "rxjs";
import { loadScript, setDefaultOptions } from "esri-loader";
import { loadModules, loadCss } from "esri-loader";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/app.reducer";
import { SetRedAguaAction } from "../../store/actions/AdmMapa/RedAgua/RedAgua.actions";
import proj4 from "proj4";
import {
  GetDataNissAction,
  HiddenDataNissAction,
} from "../../store/actions/AdmMapa/BusquedaNiss.actions";
import {
  SelectGAction,
  UnselectGAction,
  SetRARAction,
  VisiblePDAction,
  ActivarFichaPDAction,
  VisualizarDNAction,
  OcultarDNAction,
} from "src/app/store/actions";
import { ResultAR } from "src/app/models/SicarMap/resultAR.model";
import { element } from "protractor";
import { SelectViewAction } from "src/app/store/actions/Componentes/CortarPoligono/SelectView.actions";
import { AuthService } from "./auth.service";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { FeactureService } from "./FeactureService.service";
import { data, event } from "jquery";
import { print } from "util";
import { FeatureformService } from "./FeatureformService.service";
// import widget from 'esri/widgets/support/widget';

declare var $: any;

@Injectable({
  providedIn: "root",
})
export class MapaService implements OnDestroy {
  AreaTrabajo: any[] = [];
  RegLyrSelect: any[] = [];
  public MapaBaseComplete = new Subject<{ [key: string]: boolean }>();
  public ejecutaAnalisis = new BehaviorSubject<boolean>(false);

  public view: any;

  public print: any;

  public mapaSource: any;
  public Servicios: any[];
  public measurement: any;
  public editor;
  public featureForm;
  public search;
  public sketch;
  public ConfiguracionLayers = [];
  public analisis1RD = false;
  public analisi2RD = false;
  public GraficosTomas = [];
  public GraficosValvulas = [];

  public RedAguaMapImage = new BehaviorSubject<any>(null);

  public ActiveCortarP = false;
  public opcionMapa = "2D";

  public basemapGallery;
  public scaleBar;

  public DatosSuministro = 2;
  public CapasEncendidas: any[] = [];

  nissActive;

  highlight: any;
  responseHandler: any;
  editFeature: any;
  fieldsLayer: any[];
  fieldsLayerFilter: any[];

  constructor(
    private store: Store<AppState>,
    private ServAuth: AuthService,
    private featureServ: FeatureformService
  ) {
    proj4.defs([
      [
        "EPSG:4326",
        "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees",
      ],
      [
        "EPSG:4269",
        "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees",
      ],
      [
        "EPSG:32614",
        "+proj=utm +zone=14 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
      ],
      [
        "EPSG:3395",
        "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
      ],
      [
        "EPSG:3857",
        "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs",
      ],
    ]);
    // loadCss('https://js.arcgis.com/4.23/esri/themes/light/main.css');
    //var options = { url: 'https://js.arcgis.com/4.24/init.js' };

    //loadCss('https://arcgisouc.aguapuebla.mx:121/javascript/api/4.22/esri/themes/light/main.css');
    //var options = { url: 'https://js.arcgis.com/4.22/init.js' };
    //var options = { url: 'https://arcgisouc.aguapuebla.mx:121/javascript/api/4.22/init.js' };

    loadCss(
      "https://arcgisouc.aguapuebla.mx:121/javascript/api/4.22/esri/themes/light/main.css"
    );
    var options = {
      url: "https://arcgisouc.aguapuebla.mx:121/javascript/api/4.22/init.js",
    };

    /* loadCss('https://arcgisouc.aguapuebla.mx:121/library/4.16/esri/css/main.css');
    var options = { url: 'https://arcgisouc.aguapuebla.mx:121/library/4.16/init.js' }; */

    loadScript(options);
    /* loadCss();
    setDefaultOptions({ version: '4.16' }); */
  }

  getMapaBaseComplete(contenedor): Observable<any> {
    if (!this.mapaSource) {
      this.inicializaMapaBase(contenedor, "Inicio");
    }
    return this.MapaBaseComplete.asObservable();
  }

  removeFeatures() {
    this.mapaSource = null;
    return this.MapaBaseComplete.asObservable();
  }

  async inicializaMapaBase(contenedor, opcionI) {
    try {
      const [Map, MapView, WebScene, SceneView, IdentityManager] =
        await loadModules([
          "esri/Map",
          "esri/views/MapView",
          "esri/WebScene",
          "esri/views/SceneView",
          "esri/identity/IdentityManager",
        ]);
      const mapViewProperties = {
        container: document.getElementById(contenedor),
        map: {
          basemap: "topo-vector",
        },
      };
      this.view = new MapView(mapViewProperties);

      // this.view.print();

      //console.log(this.view);

      let mapa = document.getElementById(contenedor);
      //console.log(mapa);

      this.view.when(
        () => {
          this.mapaSource = this.view.map;

          this.mapaSource.watch("basemap", (newVal) => {
            console.log("MapaBase Select", newVal);
          });
          this.visualizarExtendGeneral();
          if (opcionI == "Inicio") {
            this.MapaBaseComplete.next({ topo: true });
          }

          if (opcionI == "Cambio") {
            if (this.Servicios) {
              this.inicializarComplementos();
            }
          }

          if (this.ServAuth.Usuario.pidperfil == 60) {
            this.view.goTo({
              center: [-99.916865, 25.51431],
              zoom: 8,
            });
          }
        },
        (error) => {
          this.MapaBaseComplete.error(error);
        }
      );

      this.view.on("click", (event) => {
        this.view.hitTest(event).then((response) => {
          if (this.ActiveCortarP) {
            var lat = Math.round(event.mapPoint.latitude * 1000) / 1000;
            var lon = Math.round(event.mapPoint.longitude * 1000) / 1000;
            this.store.dispatch(
              new SelectViewAction(
                this.generarGeometriaPunto(
                  event.mapPoint.longitude,
                  event.mapPoint.latitude
                )
              )
            );
          }
          if (response.results.length > 0) {
            var layerNIS = response.results.find(
              (x) =>
                x.graphic.layer !== undefined &&
                x.graphic.layer !== null &&
                (x.graphic.layer.id == "11_ItemCarto" ||
                  x.graphic.layer.id == "97_ItemCarto" ||
                  x.graphic.layer.id == "182_ItemCarto")
            );
            if (layerNIS) {
              if (layerNIS.graphic.attributes["NISRAD"] !== undefined) {
                this.nissActive = layerNIS.graphic.attributes["NISRAD"];
              } else if (layerNIS.graphic.attributes["NISS"] !== undefined) {
                this.nissActive = layerNIS.graphic.attributes["NISS"];
              } else {
                this.nissActive = undefined;
              }
            } else {
              this.nissActive = undefined;
            }
            // if (layerNIS) {
            //   if ((layerNIS.graphic.attributes['NISRAD'] || layerNIS.graphic.attributes['NIS'] || layerNIS.graphic.attributes['NISS']) &&
            //     (layerNIS.graphic.attributes['NISRAD'] !== 0 || layerNIS.graphic.attributes['NIS'] !== 0 || layerNIS.graphic.attributes['NISS'] !== 0) &&
            //     (layerNIS.graphic.attributes['NISRAD'] !== null || layerNIS.graphic.attributes['NIS'] !== null || layerNIS.graphic.attributes['NISS'] !== null)) {
            //     if (this.editor === undefined || this.editor.destroyed) {
            //       this.view.graphics.removeAll();
            //       this.view.graphics.add({
            //         geometry: layerNIS.graphic.geometry,
            //         symbol: {
            //           type: 'simple-marker',
            //           color: [255, 100, 95, 0.8],
            //           size: 12,
            //           outline: {
            //             color: [255, 0, 0],
            //             width: 4
            //           }
            //         },
            //         attributes: layerNIS.graphic.attributes
            //       });
            //       let nis = 0;
            //       if (layerNIS.graphic.attributes['NISRAD'] !== undefined) {
            //         nis = layerNIS.graphic.attributes['NISRAD'];
            //       } else  if (layerNIS.graphic.attributes['NIS'] !== undefined) {
            //         nis = layerNIS.graphic.attributes['NIS'];
            //       } else  if (layerNIS.graphic.attributes['NISS'] !== undefined) {
            //         nis = layerNIS.graphic.attributes['NISS'];
            //       }
            //       //this.store.dispatch(new GetDataNissAction(nis));
            //       if (this.DatosSuministro == 1) {
            //         this.view.popup.autoOpenEnabled = false;
            //         this.store.dispatch(new GetDataNissAction(nis));
            //       } else if (this.DatosSuministro == 3 || this.DatosSuministro == 2) {
            //         this.view.popup.autoOpenEnabled = true;
            //         this.store.dispatch(new VisualizarDNAction(nis.toString()));
            //       }
            //     } else {
            //       this.view.popup.autoOpenEnabled = true;
            //     }
            //   } else {
            //     this.view.popup.autoOpenEnabled = true;
            //   }
            // } else {
            //   this.view.popup.autoOpenEnabled = true;
            // }
          } else {
            this.nissActive = undefined;
          }
        });
      });

      this.view.popup.on("trigger-action", (event) => {
        if (event.action.id === "searchniss-this") {
          if (this.nissActive) {
            if (this.DatosSuministro == 1) {
              this.view.popup.autoOpenEnabled = false;
              this.store.dispatch(new GetDataNissAction(this.nissActive));
            } else if (this.DatosSuministro == 3 || this.DatosSuministro == 2) {
              this.view.popup.autoOpenEnabled = true;
              this.store.dispatch(new VisualizarDNAction(this.nissActive));
            }
          }
        }
      });
      this.view.watch("popup.visible", (event) => {
        if (!event) {
          this.nissActive = undefined;
        }
      });

      this.view.watch(
        "popup.selectedFeature",
        (newValue, oldValue, property, object) => {
          if (newValue) {
            //console.log(newValue);
            this.store.dispatch(new SelectGAction(newValue));
          }
        }
      );
      this.view.watch(
        "popup.visible",
        (newValue, oldValue, property, object) => {
          if (!newValue) {
            this.store.dispatch(new UnselectGAction());
          }
        }
      );
    } catch (error) {
      this.MapaBaseComplete.error(error);
    }

    this.getToken(this.ServAuth);
  }

  async getToken(ServAuth) {
    const [IdentityManager] = await loadModules([
      "esri/identity/IdentityManager",
    ]);

    await ServAuth.getTokenPortal().subscribe((data) => {
      IdentityManager.registerToken({
        token: data.token,
        server: "https://arcgisoucportal.aguapuebla.mx/arcgis/sharing",
        ssl: true,
      });
      IdentityManager.checkSignInStatus(
        "https://arcgisoucportal.aguapuebla.mx/arcgis/sharing"
      ).then((data) => {});
    });
  }

  //Función Exportar Mapa ---
  async ImpriMap() {
    const [MapView, Print, WebMap] = await loadModules([
      "esri/views/MapView",
      "esri/widgets/Print",
      "esri/WebMap",
    ]);

    if (this.print != undefined) {
      this.view.ui.remove(this.print, "top-left");
      this.print = undefined;
    } else {
      this.view.when(() => {
        this.print = new Print({
          view: this.view,
          printServiceUrl:
            "https://arcgisouc.aguapuebla.mx/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task",
        });
        this.print.allowedFormats = ["jpg", "png8", "pdf"];
        this.view.ui.add(this.print, "top-right");
      });
    }
  }

  //Funcion para cerrar el widget export
  cerrarExportar() {
    if (this.print == undefined || this.print != undefined) {
      this.view.ui.remove(this.print, "top-left");
      this.print = undefined;
    }
  }

  GenerarLayers() {}

  async inicializaMapaBase3d(contenedor, opcionI) {
    try {
      const [Map, MapView, WebScene, SceneView] = await loadModules([
        "esri/Map",
        "esri/views/MapView",
        "esri/WebScene",
        "esri/views/SceneView",
      ]);

      var map = new Map({
        basemap: "topo-vector",
        ground: "world-elevation",
      });

      // Create the MapView
      this.view = new SceneView({
        container: document.getElementById(contenedor),
        map: map,
      });

      this.view.when(
        () => {
          this.mapaSource = this.view.map;
          this.mapaSource.watch("basemap", (newVal) => {
            console.log("MapaBase Select", newVal);
          });
          this.visualizarExtendGeneral();

          if (opcionI == "Inicio") {
            this.MapaBaseComplete.next({ topo: true });
          }

          if (opcionI == "Cambio") {
            if (this.Servicios) {
              this.inicializarComplementos();
            }
          }
        },
        (error) => {
          this.MapaBaseComplete.error(error);
        }
      );

      this.view.on("click", (event) => {
        this.view.hitTest(event).then((response) => {
          if (this.ActiveCortarP) {
            var lat = Math.round(event.mapPoint.latitude * 1000) / 1000;
            var lon = Math.round(event.mapPoint.longitude * 1000) / 1000;
            this.store.dispatch(
              new SelectViewAction(
                this.generarGeometriaPunto(
                  event.mapPoint.longitude,
                  event.mapPoint.latitude
                )
              )
            );
          }
          if (response.results.length > 0) {
            var layerNIS = response.results.find(
              (x) =>
                x.graphic.attributes !== undefined &&
                x.graphic.attributes !== null &&
                (x.graphic.attributes.hasOwnProperty("NISRAD") ||
                  x.graphic.attributes.hasOwnProperty("NIS"))
            );
            if (layerNIS) {
              if (
                (layerNIS.graphic.attributes["NISRAD"] ||
                  layerNIS.graphic.attributes["NIS"]) &&
                (layerNIS.graphic.attributes["NISRAD"] !== 0 ||
                  layerNIS.graphic.attributes["NIS"] !== 0) &&
                (layerNIS.graphic.attributes["NISRAD"] !== null ||
                  layerNIS.graphic.attributes["NIS"] !== null)
              ) {
                if (this.editor === undefined || this.editor.destroyed) {
                  this.view.graphics.removeAll();
                  this.view.graphics.add({
                    geometry: layerNIS.graphic.geometry,
                    symbol: {
                      type: "simple-marker",
                      color: [255, 100, 95, 0.8],
                      size: 12,
                      outline: {
                        color: [255, 0, 0],
                        width: 4,
                      },
                    },
                    attributes: layerNIS.graphic.attributes,
                  });
                  let nis = 0;
                  if (layerNIS.graphic.attributes["NISRAD"] !== undefined) {
                    this.view.popup.autoOpenEnabled = false;
                    nis = layerNIS.graphic.attributes["NISRAD"];
                  } else {
                    this.view.popup.autoOpenEnabled = false;
                    nis = layerNIS.graphic.attributes["NIS"];
                  }
                  //this.store.dispatch(new GetDataNissAction(nis));
                  if (this.DatosSuministro == 1) {
                    this.store.dispatch(new GetDataNissAction(nis));
                  } else if (
                    this.DatosSuministro == 3 ||
                    this.DatosSuministro == 2
                  ) {
                    this.store.dispatch(new VisualizarDNAction(nis.toString()));
                  }
                } else {
                  this.view.popup.autoOpenEnabled = true;
                }
              } else {
                this.view.popup.autoOpenEnabled = true;
              }
            } else {
              this.view.popup.autoOpenEnabled = true;
            }
          }
        });
      });

      this.view.watch(
        "popup.selectedFeature",
        (newValue, oldValue, property, object) => {
          if (newValue) {
            this.store.dispatch(new SelectGAction(newValue));
          }
        }
      );
      this.view.watch(
        "popup.visible",
        (newValue, oldValue, property, object) => {
          if (!newValue) {
            this.store.dispatch(new UnselectGAction());
          }
        }
      );
    } catch (error) {
      this.MapaBaseComplete.error(error);
    }
  }

  CambiarMapa() {
    /* this.view.map.destroy();
    this.view.map = null; */
    this.CapasEncendidas = [];
    this.view.map.layers.forEach((layer) => {
      if (layer.type === "feature" && layer.id.split("_")[1] === "ItemCarto")
        this.CapasEncendidas.push({ id: layer.id, url: layer.url });
    });
    this.view.destroy();
    this.view = null;
    if (this.opcionMapa == "2D") {
      this.opcionMapa = "3D";
      this.inicializaMapaBase3d("ContenedorMapa", "Cambio");
    } else {
      this.opcionMapa = "2D";
      this.inicializaMapaBase("ContenedorMapa", "Cambio");
    }
    console.log("move");
  }

  inicializarComplementos() {
    //this.inicializarMapaDinamicoRedAgua();
    this.InicializarCambioMapas();
    this.inicializarComponentes();
    this.store.dispatch(new SetRedAguaAction());
    this.inicializarGraficoDibujo("Ubicacion");
    this.inicializarGraficoDibujo("RedAguaAnalisis");
    this.inicializarGraficoDibujo("RedAguaAnalisisResult");
    this.inicializarGraficoDibujo("StretView");
    this.inicializarGraficoDibujo("Area");
  }

  async inicializarGraficoDibujo(nombre: string) {
    const [GraphicsLayer] = await loadModules(["esri/layers/GraphicsLayer"]);
    const layerSelect = new GraphicsLayer({
      graphics: [],
      id: nombre,
    });
    if (this.mapaSource) {
      this.mapaSource.add(layerSelect);
      return layerSelect;
    }
  }

  async InicializarFeatureForm() {
    const [FeatureForm] = await loadModules(["esri/widgets/FeatureForm"]);
    this.featureForm = new FeatureForm({
      viewModel: this.view,
      container: document.getElementById("formDiv"),
      groupDisplay: "all",
    });
  }

  async InicializarEditor() {
    const [Editor] = await loadModules(["esri/widgets/Editor"]);
    this.editor = new Editor({
      view: this.view,
      container: document.getElementById("editorDiv"),
      supportingWidgetDefaults: {
        featureTemplates: {
          groupBy: (e) => {
            const elementConfig = this.ConfiguracionLayers.find(
              (CE) => CE.layer === e.layer.id
            );
            console.log(elementConfig);
            if (
              elementConfig &&
              elementConfig.Validacion &&
              !this.ServAuth.Usuario.supervisor
            ) {
              if (e.template.name == "Pendiente") {
                return "Red Distribución Rev.";
              }
            } else {
              return e.layer.title;
            }
          },
        },
      },
    });

    this.editor.viewModel.featureFormViewModel.on("change", (event) => {
      console.log("change", event);
    });

    this.editor.viewModel.featureFormViewModel.on("value-change", (event) => {
      console.log("value-change", event);
    });

    this.editor.watch("activeWorkflow ", (evento) => {
      //console.log(this.editor.layerInfos);
    });

    console.log(this.mapaSource);
    for (let i = this.mapaSource.layers.items.length - 1; i >= 0; i--) {
      const element = this.mapaSource.layers.items[i];
      if (
        element.type === "feature" &&
        element.id.split("_")[1] === "ItemCarto"
      ) {
        const elementConfig = this.ConfiguracionLayers.find(
          (CE) => CE.layer === element.id
        );
        console.log(elementConfig);
        if (
          elementConfig &&
          elementConfig.Validacion &&
          !this.ServAuth.Usuario.supervisor
        ) {
          this.GenerarFiltroValidacion(element);
        }
      }
    }

    this.editor.viewModel.sketchViewModel.on("create", (event) => {
      if (event.state === "complete") {
        var usuario = this.ServAuth.Usuario;
        // var valores =  this.editor.activeWorkflow;
        const elementConfig = this.ConfiguracionLayers.find(
          (element) => element.layer === "61_ItemCarto"
        );
        if (elementConfig && elementConfig.Validacion) {
          if (!this.ServAuth.Usuario.supervisor) {
            event.graphic.attributes.ESTADO_REVISION = "Pendiente";
          }
        }
      }
    });
    this.editor.viewModel.sketchViewModel.on("update", (event) => {
      console.log("va a editar", event);
      if (event.state === "complete") {
        var usuario = this.ServAuth.Usuario;
        const elementConfig = this.ConfiguracionLayers.find(
          (element) =>
            element.layer ===
            this.editor.viewModel.featureFormViewModel.layer.id
        );

        if (elementConfig && elementConfig.Validacion) {
          if (this.ServAuth.Usuario.supervisor) {
            const now = new Date();
            var NameUser =
              this.ServAuth.Usuario.snombre +
              " " +
              this.ServAuth.Usuario.sapellidoPaterno +
              " " +
              this.ServAuth.Usuario.sapellidoMaterno;
            var utc_timestamp = Date.UTC(
              now.getFullYear(),
              now.getMonth(),
              now.getDate(),
              now.getHours(),
              now.getMinutes(),
              now.getSeconds(),
              now.getMilliseconds()
            );
            //this.editor.viewModel.featureFormViewModel.feature.attributes.ESTADO_REVISION= "Supervisado";
            this.editor.viewModel.featureFormViewModel.feature.attributes.SUPERVISO =
              NameUser;
            this.editor.viewModel.featureFormViewModel.feature.attributes.FECHA_SUPERVISION =
              utc_timestamp;
          } else {
            const now = new Date();

            var NameUser =
              this.ServAuth.Usuario.snombre +
              " " +
              this.ServAuth.Usuario.sapellidoPaterno +
              " " +
              this.ServAuth.Usuario.sapellidoMaterno;
            var utc_timestamp = Date.UTC(
              now.getFullYear(),
              now.getMonth(),
              now.getDate(),
              now.getHours(),
              now.getMinutes(),
              now.getSeconds(),
              now.getMilliseconds()
            );
            this.editor.viewModel.featureFormViewModel.feature.attributes.ESTADO_REVISION =
              "Revisado";
            this.editor.viewModel.featureFormViewModel.feature.attributes.REVISO =
              NameUser;
            this.editor.viewModel.featureFormViewModel.feature.attributes.FECHA_REVISION =
              utc_timestamp;
          }
        }
      }
    });
    return this.editor;
  }

  async GenerarFiltroValidacion(layer) {
    /* const [FeatureFilter] = await loadModules(['esri/layers/support/FeatureFilter']);
    this.view.whenLayerView(layer)
      .then((layerView) => {
        layerView.filter = new FeatureFilter({
          where: "ESTADO_REVISION = 'Revisado'"
        });
      }).catch(console.error); */
  }
  async QuitarFiltroValidacion(layer) {
    /*  const [FeatureFilter] = await loadModules(['esri/layers/support/FeatureFilter']);
     this.view.whenLayerView(layer)
       .then((layerView) => {
         layerView.filter =  null;
       }).catch(console.error); */
  }

  customGroup(grouping) {
    // If the layer is 'Police routes', do not group.
    let groupHeading = "Capas Activas";
    /* if (grouping.layer.title.toLowerCase() === "crime map") {
      switch (grouping.template.name) {
        case "Criminal Homicide":
        case "Rape":
        case "Robbery":
        case "Aggravated Assault":
          groupHeading = "Violent Crime";
          break;
        case "Arson":
        case "Burglary":
        case "Larceny":
        case "Motor Vehicle Theft":
          groupHeading = "Property Crime";
          break;
        default:
          groupHeading = "Quality of Life";
      }
    } */
    return grouping.layer.title;
  }

  cargarFormLayersInfos(FiedlsFeatures: any[], view = this.view) {
    console.log(FiedlsFeatures);
    if (this.featureForm) {
      this.unselectFeature();
      const layerInfos: any[] = [];
      this.mapaSource.layers.forEach((layerC) => {
        if (layerC.type === "feature") {
          const elementConfig = this.ConfiguracionLayers.find(
            (element) => element.layer === layerC.id
          );
          console.log(elementConfig);
          if (elementConfig && layerC.id.split("_")[1] === "ItemCarto") {
            const habilitado =
              Boolean(elementConfig.Agregar) ||
              Boolean(elementConfig.Edicion) ||
              Boolean(elementConfig.Eliminacion);
            if (habilitado) {
              view.on("click", (event) => {
                view.hitTest(event).then((response) => {
                  // If user selects a feature, select it
                  const results = response.results;
                  if (
                    results.length > 0 &&
                    results[0].graphic &&
                    results[0].graphic.layer === layerC
                  ) {
                    //console.log(results[0].graphic.attributes[layerC.objectIdField]);
                    this.selectFeature(
                      results[0].graphic.attributes[layerC.objectIdField],
                      layerC
                    );
                  } else {
                    // Hide the form and show the info div
                    document
                      .getElementById("update")
                      .classList.add("esri-hidden");
                  }
                });
              });
            }
          } else {
            var Definitionfield = this.generarFieldConfig(layerC.fields);
            //const elementConfig = this.ConfiguracionLayers.find(element => element.layer === layerC.id);
            if (
              elementConfig &&
              elementConfig.Validacion &&
              this.ServAuth.Usuario.supervisor
            ) {
              /*  Definitionfield.push({
                name: "ESTADO_REVISION",
                label: "Estado Revision"
              }); */
            } else if (
              elementConfig &&
              elementConfig.Validacion &&
              !this.ServAuth.Usuario.supervisor
            ) {
              Definitionfield[25].editable = false;
            }
            layerInfos.push({
              layer: layerC,
              fieldConfig: Definitionfield,
              // formTemplate: { elements: Definitionfield },
              enabled: false,
              addEnabled: false,
              updateEnabled: false,
              deleteEnabled: false,
            });
          }
        }
      });
    }
  }

  unselectFeature = () => {
    if (this.highlight) {
      this.highlight.remove();
    }
  };

  selectFeature(objectId, layer) {
    // query feature from the server
    layer
      .queryFeatures({
        objectIds: [objectId],
        outFields: ["*"],
        returnGeometry: true,
      })
      .then((results) => {
        if (results.features.length > 0) {
          this.editFeature = results.features[0];

          // display the attributes of selected feature in the form
          this.featureForm.feature = this.editFeature;

          // highlight the feature on the view
          this.view.whenLayerView(this.editFeature.layer).then((layerView) => {
            this.highlight = layerView.highlight(this.editFeature);
          });

          if (
            document.getElementById("update").classList.contains("esri-hidden")
          ) {
            document.getElementById("info").classList.add("esri-hidden");
            document.getElementById("update").classList.remove("esri-hidden");
          }
        }
      });
  }

  cargarLayersInfos(FiedlsFeatures: any[]) {
    if (this.editor) {
      const layerInfos: any[] = [];
      this.mapaSource.layers.forEach((layerC) => {
        if (layerC.type === "feature") {
          const elementConfig = this.ConfiguracionLayers.find(
            (element) => element.layer === layerC.id
          );

          if (elementConfig && layerC.id.split("_")[1] === "ItemCarto") {
            const habilitado =
              Boolean(elementConfig.Agregar) ||
              Boolean(elementConfig.Edicion) ||
              Boolean(elementConfig.Eliminacion);
            if (habilitado) {
              var caracteristicas = FiedlsFeatures.find(
                (x) => x.id === layerC.id
              );
              var Definitionfield = [];
              if (caracteristicas) {
                Definitionfield = this.generarFieldConfigPer(
                  caracteristicas.campos
                );
              } else {
                Definitionfield = this.generarFieldConfig(layerC.fields);
              }

              //console.log(Definitionfield)
              if (
                elementConfig.Validacion &&
                this.ServAuth.Usuario.supervisor
              ) {
                /*  Definitionfield.push({
                  name: "ESTADO_REVISION",
                  label: "Estado Revision"
                }); */
                if (!elementConfig.Eliminacion)
                  elementConfig.Eliminacion = true;
              } else if (
                elementConfig.Validacion &&
                !this.ServAuth.Usuario.supervisor
              ) {
                console.log(layerC.id);
                if (layerC.id == "262_ItemCarto") {
                  Definitionfield[31].editable = false;
                } else if (layerC.id == "67_ItemCarto") {
                  Definitionfield[25].editable = false;
                } else if (layerC.id == "190_ItemCarto") {
                  Definitionfield[21].editable = false;
                } else if (
                  ["158_ItemCarto", "199_ItemCarto"].includes(layerC.id)
                ) {
                  Definitionfield[27].editable = false;
                }
              }

              /*  if(caracteristicas.id.split('_')[0] == '74'){

                Definitionfield.splice(12,0,{
                  name: "GIRO",
                  label: 'GIRO'
                });

              } */

              var LayInfo = {
                layer: layerC,
                fieldConfig: Definitionfield,
                // formTemplate: { elements: Definitionfield },
                enabled: habilitado,
                allowAttachments: true,
                addEnabled: Boolean(elementConfig.Agregar),
                updateEnabled: Boolean(elementConfig.Edicion),
                deleteEnabled: Boolean(elementConfig.Eliminacion),
              };

              layerInfos.push(LayInfo);
            }
          } else {
            var Definitionfield = this.generarFieldConfig(layerC.fields);
            //const elementConfig = this.ConfiguracionLayers.find(element => element.layer === layerC.id);
            if (
              elementConfig &&
              elementConfig.Validacion &&
              this.ServAuth.Usuario.supervisor
            ) {
              /*  Definitionfield.push({
                name: "ESTADO_REVISION",
                label: "Estado Revision"
              }); */
            } else if (
              elementConfig &&
              elementConfig.Validacion &&
              this.ServAuth.Usuario.supervisor
            ) {
              Definitionfield[25].editable = false;
            }
            layerInfos.push({
              layer: layerC,
              fieldConfig: Definitionfield,
              //formTemplate: { elements: Definitionfield },
              enabled: false,
              addEnabled: false,
              updateEnabled: false,
              deleteEnabled: false,
            });
          }
        }
      });
      this.editor.layerInfos = layerInfos;
    }
  }
  removerConfiguracionEditorLayer(layer) {
    const elementConfig = this.ConfiguracionLayers.find(
      (element) => element.layer === layer
    );
    if (elementConfig) {
      this.ConfiguracionLayers.splice(
        this.ConfiguracionLayers.indexOf(elementConfig),
        1
      );
    }
  }
  generarFieldConfig(campos) {
    const FieldInfos: any[] = [];
    campos.forEach((item) => {
      FieldInfos.push({
        name: item.name,
        label: item.alias,
      });
    });
    console.log(FieldInfos);
    return FieldInfos;
  }
  generarFieldConfigPer(campos) {
    const FieldInfos: any[] = [];
    // DESHABILITAR CAMPOS PARA EDICION
    campos.forEach((item) => {
      if (!item.boculto) {
        FieldInfos.push({
          //fieldName: item.scampo,
          name: item.scampo,
          label: item.salias,
          required: item.brequerido,
          editable: !item.bdeshabilitado,
        });
      }
    });
    return FieldInfos;
  }
  // Operaciones Skech
  ValidarSkech() {
    const layerD = this.mapaSource.findLayerById("LayersGraficoDibujo");
    if (!layerD) {
      this.inicializarGraficoDibujo("LayersGraficoDibujo").then((layerDB) => {
        this.GenerarSkech(layerDB);
      });
    } else {
      this.GenerarSkech(layerD);
    }
  }
  async GenerarSkech(layerD) {
    const [Sketch] = await loadModules(["esri/widgets/Sketch"]);
    const contenedorD = document.getElementById("ContenedorDibujo");
    this.sketch = new Sketch({
      layer: layerD,
      container: contenedorD,
      view: this.view,
    });
    (this.sketch.viewModel.polylineSymbol = {
      type: "simple-line", //autocasts as new SimpleLineSymbol()
      color: "red",
      width: "4px",
      style: "solid",
    }),
      (this.sketch.viewModel.polygonSymbol = {
        type: "simple-fill",
        color: [255, 255, 255, 0.5],
        style: "solid",
        outline: {
          color: "red",
          size: "10px",
        },
      });
  }
  DestruirSkech() {
    this.sketch.destroy();
  }
  // Operaciones Measure
  async GenerarMeasure() {
    if (this.opcionMapa == "2D") {
      const [Measurement] = await loadModules(["esri/widgets/Measurement"]);
      this.measurement = new Measurement({
        view: this.view,
        container: document.getElementById("ContenedorInfoMeasure"),
      });
    } else {
      const [Measurement] = await loadModules([
        "esri/widgets/DirectLineMeasurement3D",
      ]);
      this.measurement = new Measurement({
        view: this.view,
        container: document.getElementById("ContenedorInfoMeasure"),
      });
    }
  }
  async InicializarCambioMapas() {
    try {
      if (this.basemapGallery != null) {
        this.basemapGallery.view = this.view;
      } else {
        const [Expand, BasemapGallery] = await loadModules([
          "esri/widgets/Expand",
          "esri/widgets/BasemapGallery",
        ]);
        this.basemapGallery = new BasemapGallery({
          view: this.view,
          container: document.getElementById("ContenedorMapasBase"),
        });
        // this.basemapGallery.print();
        //console.log(this.basemapGallery);
      }
    } catch (error) {
      console.log("EsriLoader: ", error);
    }
  }
  async inicializarComponentes() {
    try {
      const [Locator, Search, FeatureLayer, ScaleBar] = await loadModules([
        "esri/tasks/Locator",
        "esri/widgets/Search",
        "esri/layers/FeatureLayer",
        "esri/widgets/ScaleBar",
      ]);
      this.view.ui.move(["zoom"], "top-right");
      let urlsuministros = this.Servicios.find((x) => x.servicio == "Usuarios");
      this.DatosSuministro = Number(
        this.Servicios.find((x) => x.servicio == "DatosSuministro")[
          "urlServicio"
        ]
      );
      this.search = new Search({
        view: this.view,
        searchAllEnabled: false,
        locationEnabled: false,
        includeDefaultSources: true,
        activeSourceIndex: 1,
        allPlaceholder: "NISS o Direccion",
        sources: [
          {
            layer: new FeatureLayer({
              url: urlsuministros.urlServicio,
              outFields: ["*"],
            }),
            searchFields: ["NISRAD"],
            displayField: "NISRAD",
            exactMatch: false,
            outFields: ["*"],
            name: "NISS",
            placeholder: "Ejemplo: 2124574",
            maxResults: 6,
            maxSuggestions: 6,
            suggestionsEnabled: true,
            minSuggestCharacters: 0,
            popupEnabled: false,
            zoomScale: 18,
            autoNavigate: false,
            resultSymbol: {
              type: "simple-marker",
              color: [255, 100, 95, 0.8],
              size: 12,
              outline: {
                color: [255, 0, 0],
                width: 4,
              },
            },
          },
        ],
      });

      this.search.on("search-complete", (event) => {
        if (event.activeSourceIndex === 1) {
          if (event.results[0].results.length > 0) {
            // if (this.DatosSuministro == 1) {
            //   this.store.dispatch(new GetDataNissAction(event.searchTerm));
            // } else if (this.DatosSuministro == 2 || this.DatosSuministro == 3) {
            //   this.store.dispatch(new VisualizarDNAction(event.searchTerm));
            // }
            this.Acercamiento(
              18,
              event.results[0].results[0].extent.center.longitude + 0.0017,
              event.results[0].results[0].extent.center.latitude
            );
          } else {
            this.store.dispatch(new HiddenDataNissAction());
          }
        } else {
          this.store.dispatch(new HiddenDataNissAction());
        }
      });

      this.search.on("search-start", (event) => {
        if (this.DatosSuministro == 1) {
          this.store.dispatch(new HiddenDataNissAction());
        } else {
          this.store.dispatch(new OcultarDNAction());
        }
        this.view.graphics.removeAll();
      });

      this.search.on("search-clear", (event) => {
        if (this.DatosSuministro == 1) {
          this.store.dispatch(new HiddenDataNissAction());
        } else {
          this.store.dispatch(new OcultarDNAction());
        }
        //this.visualizarExtendGeneral();
        this.view.graphics.removeAll();
      });
      const handler = this.search.on("search-focus", (event) => {
        handler.remove();
        const input = $(".esri-search__input");
        if (input && input.length > 0) {
          input[0].onfocusout = null;
        }
      });

      this.search.view = this.view;
      this.view.ui.add(this.search, "top-right");
      this.view.ui.move({
        component: this.search,
        position: "top-right",
        index: 0,
      });

      this.view.watch("stationary", (isStationary) => {
        this.showCoordinates(this.view.center, this.view);
      });
      this.view.on("pointer-move", (evt) => {
        this.showCoordinates(
          this.view.toMap({ x: evt.x, y: evt.y }),
          this.view
        );
      });

      if (this.opcionMapa == "2D") {
        this.scaleBar = new ScaleBar({
          view: this.view,
          unit: "dual",
        });
        this.view.ui.add(this.scaleBar, {
          position: "bottom-left",
        });
      }
    } catch (error) {
      console.log("EsriLoader: ", error);
    }
  }
  showCoordinates(pt, viewP) {
    if (pt && pt.latitude && pt.longitude) {
      const coords =
        "Lat/Lon " +
        pt.latitude.toFixed(6) +
        " " +
        pt.longitude.toFixed(6) +
        " | Scale 1:" +
        Math.round(viewP.scale * 1) / 1 +
        " | Zoom " +
        viewP.zoom;
      var contenedor = document.getElementById("coordsWidget");
      if (contenedor) {
        contenedor.innerHTML = coords;
      }
    }
  }
  async inicializarMapaDinamicoRedAgua() {
    try {
      const [MapImageLayer] = await loadModules(["esri/layers/MapImageLayer"]);
      const layer = new MapImageLayer({
        url: "https://arcgisouc.aguapuebla.mx/arcgis/rest/services/FlujosAgua/FlujoAguas/MapServer",
      });
      layer.id = "MapaRedAguaPuebla";
      layer.visible = false;
      layer.when(
        () => {
          this.RedAguaMapImage.next(layer);
        },
        (error) => {
          this.RedAguaMapImage.error(error);
        }
      );
      this.mapaSource.add(layer, 1);
    } catch (error) {
      return error;
    }
  }

  visualizarRed() {
    const layerB = this.mapaSource.findLayerById("MapaRedAguaPuebla");
    const nuevaProyection = proj4.transform(
      proj4.Proj("EPSG:3395"),
      proj4.Proj("EPSG:4326"),
      [layerB.fullExtent.center.x, layerB.fullExtent.center.y]
    );
    //this.Acercamiento(16, nuevaProyection.x, nuevaProyection.y);
    layerB.visible = true;
  }

  ocultarRed() {
    const layerB = this.mapaSource.findLayerById("MapaRedAguaPuebla");
    layerB.visible = false;
    this.visualizarExtendGeneral();
  }

  generarGeometriaPunto(x: number, y: number): any {
    const pointGraphic = {
      geometry: {
        type: "point",
        x,
        y,
        spatialReference: { wkid: 4326 },
      },
      symbol: {
        type: "simple-marker",
        color: [226, 119, 40],
        size: 12,
        outline: {
          color: [255, 255, 255],
          width: 2,
        },
      },
      attributes: {
        OBJECTID: 0,
      },
    };
    return pointGraphic;
  }

  generarGeometriaArea(Area) {
    const pointGraphic = {
      geometry: Area.geometry,
      symbol: {
        type: "simple-fill", // autocasts as new SimpleFillSymbol()
        color: "transparent",
        outline: {
          // autocasts as new SimpleLineSymbol()
          color: [240, 20, 20, 0.8],
          width: "4px",
        },
      },
      attributes: Area.attributes,
    };
    return pointGraphic;
  }
  // 10, 116, 134
  generarGeometriaPuntoResultValvulas(
    x: number,
    y: number,
    atributes: any
  ): any {
    let pointGraphic = {
      geometry: {
        type: "point",
        x,
        y,
      },
      symbol: {
        type: "simple-marker",
        color: [20, 134, 10, 0.5],
        size: 20,
        outline: {
          color: [20, 134, 10, 0.5],
          width: 3,
        },
      },
      attributes: atributes,
    };
    return pointGraphic;
  }
  generarGeometriaPuntoResult(x: number, y: number, atributes: any): any {
    let pointGraphic = {
      geometry: {
        type: "point",
        x,
        y,
      },
      symbol: {
        type: "simple-marker",
        color: [255, 0, 0, 0.5],
        size: 20,
        outline: {
          color: [255, 0, 0, 0.5],
          width: 2,
        },
      },
      attributes: atributes,
    };
    return pointGraphic;
  }
  generarGeometriaPuntoSSymbol(x: number, y: number): any {
    let pointGraphic = {
      geometry: {
        type: "point",
        x,
        y,
        spatialReference: {
          wkid: 3395,
          latestWkid: 3395,
        },
      },
      attributes: {
        OBJECTID: 0,
      },
    };
    return pointGraphic;
  }

  LimpiarGraficos(layerId: string) {
    const layerG = this.mapaSource.findLayerById(layerId);
    layerG.removeAll();
  }

  AgregarGraficos(layerId: string, grafico) {
    const layerG = this.mapaSource.findLayerById(layerId);
    layerG.add(grafico);
  }

  ngOnDestroy() {
    if (this.view) {
      this.view.container = null;
    }
  }

  TransformarCoordenadasRed(x: number, y: number) {
    const nuevaProyection = proj4.transform(
      proj4.Proj("EPSG:4326"),
      proj4.Proj("EPSG:3395"),
      [x, y]
    );
    return nuevaProyection;
  }

  visualizarExtendGeneral() {
    if (this.AreaTrabajo.length > 0) {
      this.view.goTo(this.AreaTrabajo[0].geometry);
    } else {
      this.Acercamiento(13, -98.196, 19.037);
    }
  }

  Acercamiento(level: number, x: number, y: number) {
    if (this.opcionMapa == "2D") {
      this.view.goTo({
        center: [x, y],
        zoom: level,
      });
    } else {
      this.view.goTo({
        heading: 0, // face due east
        tilt: 0, // looking from a bird's eye view
        position: {
          latitude: y,
          longitude: x,
          z: 15000,
          spatialReference: { wkid: 3857 },
        },
      });
    }
  }

  async AcercamientoExtent(
    wkid: number,
    xmin: number,
    xmax: number,
    ymin: number,
    ymax: number
  ) {
    const [Extent] = await loadModules(["esri/geometry/Extent"]);
    const AcerExtent = new Extent({
      xmin,
      ymin,
      xmax,
      ymax,
      spatialReference: { wkid },
    });
    this.view.goTo(
      {
        target: AcerExtent,
        tilt: 60,
      },
      {
        duration: 1000,
        easing: "out-expo",
      }
    );
  }

  async EjecutarAnalisisdeRed(graficoPro) {
    try {
      this.ejecutaAnalisis.next(true);
      const [Geoprocessor, FeatureSet] = await loadModules([
        "esri/tasks/Geoprocessor",
        "esri/tasks/support/FeatureSet",
      ]);
      const gpUrl =
        "https://arcgisouc.aguapuebla.mx/arcgis/rest/services/FlujosAgua/TomasAfectadas/GPServer/TomasAfectadas";
      const gpUrl2 =
        "https://arcgisouc.aguapuebla.mx/arcgis/rest/services/FlujosAgua/Valvulas/GPServer/Valvulas";

      const inputGraphicContainer = [];
      inputGraphicContainer.push(graficoPro);

      let featureSet = new FeatureSet();
      featureSet.displayFieldName = "";
      featureSet.features = inputGraphicContainer;
      let featureSet2 = new FeatureSet();
      let params = {
        Flags: featureSet,
        Barriers: featureSet2,
      };
      let gp = new Geoprocessor(gpUrl);
      gp.outSpatialReference = {
        wkid: 3395,
      };
      gp.execute(params).then(
        (result) => {
          const arreglo: any[] = result.results[0].value.features;
          arreglo.forEach((item) => {
            const nuevaProyection = proj4.transform(
              proj4.Proj("EPSG:3395"),
              proj4.Proj("EPSG:4326"),
              [item.geometry.x, item.geometry.y]
            );
            const GraficoT = this.generarGeometriaPuntoResult(
              nuevaProyection.x,
              nuevaProyection.y,
              item.attributes
            );
            this.GraficosTomas.push(GraficoT);
            this.AgregarGraficos("RedAguaAnalisisResult", GraficoT);
          });
          this.analisis1RD = true;
          if (this.analisis1RD && this.analisi2RD) {
            this.analisis1RD = false;
            this.analisi2RD = false;
            this.store.dispatch(
              new SetRARAction(
                new ResultAR(this.GraficosTomas, this.GraficosValvulas)
              )
            );
            this.GraficosTomas = [];
            this.GraficosValvulas = [];
            this.ejecutaAnalisis.next(false);
          }
        },
        (error: any) => {
          this.analisis1RD = true;
          if (this.analisis1RD && this.analisi2RD) {
            this.analisis1RD = false;
            this.analisi2RD = false;
            this.store.dispatch(new SetRARAction(new ResultAR([], [])));
            this.GraficosTomas = [];
            this.GraficosValvulas = [];
            this.ejecutaAnalisis.next(false);
          }
        }
      );

      let gp2 = new Geoprocessor(gpUrl2);
      gp2.outSpatialReference = {
        wkid: 3395,
      };
      gp2.execute(params).then(
        (result) => {
          const arreglo: any[] = result.results[0].value.features;
          arreglo.forEach((item) => {
            const nuevaProyection = proj4.transform(
              proj4.Proj("EPSG:3395"),
              proj4.Proj("EPSG:4326"),
              [item.geometry.x, item.geometry.y]
            );
            const GraficoV = this.generarGeometriaPuntoResultValvulas(
              nuevaProyection.x,
              nuevaProyection.y,
              item.attributes
            );
            this.GraficosValvulas.push(GraficoV);
            this.AgregarGraficos("RedAguaAnalisisResult", GraficoV);
          });
          this.analisi2RD = true;
          if (this.analisis1RD && this.analisi2RD) {
            this.analisis1RD = false;
            this.analisi2RD = false;
            this.store.dispatch(
              new SetRARAction(
                new ResultAR(this.GraficosTomas, this.GraficosValvulas)
              )
            );
            this.GraficosTomas = [];
            this.GraficosValvulas = [];
            this.ejecutaAnalisis.next(false);
          }
        },
        (error: any) => {
          this.analisi2RD = true;
          if (this.analisis1RD && this.analisi2RD) {
            this.analisis1RD = false;
            this.analisi2RD = false;
            this.store.dispatch(new SetRARAction(new ResultAR([], [])));
            this.GraficosTomas = [];
            this.GraficosValvulas = [];
            this.ejecutaAnalisis.next(false);
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  agregarGraficoSelecionado(grafico) {
    const layerG = this.mapaSource.findLayerById("GraphicsSelect");
    if (layerG) {
      layerG.removeAll();
      layerG.add(this.generarGrafico(grafico.geometria));
      this.realizarValidacionAcercamiento(grafico.geometria);
    } else {
      this.inicializarGraficoDibujo("GraphicsSelect").then((layer) => {
        layer.removeAll();
        layer.add(this.generarGrafico(grafico.geometria));
        this.realizarValidacionAcercamiento(grafico.geometria);
      });
    }
  }

  generarGrafico(Geometria) {
    const Graphic = {
      geometry: Geometria,
      symbol: this.generarSimbologiaSelect(Geometria.type),
    };
    return Graphic;
  }

  realizarValidacionAcercamiento(grafico) {
    this.view.goTo([grafico]); /* .geometry */
    /* if (grafico.geometry.extent) {
      const nuevaProyectionMin = proj4.transform(proj4.Proj('EPSG:32614') ,
                  proj4.Proj('EPSG:4326'), [grafico.geometry.extent.xmin, grafico.geometry.extent.ymin]);
      const nuevaProyectionMax = proj4.transform(proj4.Proj('EPSG:32614') ,
                  proj4.Proj('EPSG:4326'), [grafico.geometry.extent.xmax, grafico.geometry.extent.ymax]);

      this.view.extent = {
        xmin: nuevaProyectionMin.x,
        ymin: nuevaProyectionMin.y,
        xmax: nuevaProyectionMax.x,
        ymax: nuevaProyectionMax.y,
        spatialReference: {
          wkid: '4326'
        }
      };

    } else {
      if (grafico.geometry.spatialReference) {
        const nuevaProyection = proj4.transform(proj4.Proj('EPSG:32614') ,
                    proj4.Proj('EPSG:4326'), [grafico.geometry.x, grafico.geometry.y]);
        this.Acercamiento(18, nuevaProyection.x, nuevaProyection.y);
      } else {
        this.Acercamiento(18, grafico.geometry.x, grafico.geometry.y);
      }
    } */
  }

  generarSimbologiaSelect(tipoG) {
    switch (tipoG) {
      case "point":
        return {
          type: "simple-marker",
          color: [0, 255, 255, 0.8],
          size: "10px",
          outline: {
            color: [0, 255, 255, 0.8],
            width: 2,
          },
        };
      case "multipoint":
        return {
          type: "simple-marker",
          color: [0, 255, 255, 0.8],
          size: "10px",
          outline: {
            color: [0, 255, 255, 0.8],
            width: 2,
          },
        };
      case "polygon":
        return {
          type: "simple-fill",
          color: [0, 255, 255, 0.5],
          style: "solid",
          outline: {
            color: [0, 255, 255, 0.8],
            width: 2,
          },
        };
      case "polyline":
        return {
          type: "simple-line",
          color: [0, 255, 255, 0.8],
          width: "2px",
          style: "solid",
        };
    }
  }

  generarSimbologiaNormal(tipoG) {
    switch (tipoG) {
      case "point":
        return {
          type: "simple-marker",
          color: [13, 78, 116, 0.8],
          size: "10px",
          outline: {
            color: [13, 78, 116, 0.8],
            width: 2,
          },
        };
      case "multipoint":
        return {
          type: "simple-marker",
          color: [13, 78, 116, 0.8],
          size: "10px",
          outline: {
            color: [13, 78, 116, 0.8],
            width: 2,
          },
        };
      case "polygon":
        return {
          type: "simple-fill",
          color: [13, 78, 116, 0.5],
          style: "solid",
          outline: {
            color: [13, 78, 116, 0.8],
            width: 2,
          },
        };
      case "polyline":
        return {
          type: "simple-line",
          color: [13, 78, 116, 0.8],
          width: "2px",
          style: "solid",
        };
    }
  }

  CambiarCursor(tipo) {
    this.view.surface.style.cursor = "crosshair";
  }

  async unirGeometrias(geometrias) {
    const [geometryEngine] = await loadModules([
      "esri/geometry/geometryEngine",
    ]);
    return geometryEngine.union(geometrias);
  }
  async cortarGeometrias(geometrias) {
    const [geometryEngine] = await loadModules([
      "esri/geometry/geometryEngine",
    ]);
    let resultado = geometryEngine.cut(geometrias[0], geometrias[1]);
    return resultado;
  }

  async TranformarGeometria(Geometria) {
    const [Polyline] = await loadModules(["esri/geometry/Polyline"]);
    let phatsT = [];
    Geometria.paths.forEach((ItPath) => {
      let phatsST = [];
      ItPath.forEach((ItSP) => {
        const nP = proj4.transform(
          proj4.Proj("EPSG:3857"),
          proj4.Proj("EPSG:32614"),
          ItSP
        );
        phatsST.push([nP.x, nP.y]);
      });
      phatsT.push(phatsST);
    });
    const line = new Polyline({
      hasZ: false,
      hasM: true,
      paths: phatsT,
      spatialReference: { wkid: 32614 },
      type: "polyline",
    });
    return line;
  }

  async ValidarGemetria(Geometria) {
    try {
      const [Polyline, Polygon, Point, geometryEngine] = await loadModules([
        "esri/geometry/Polyline",
        "esri/geometry/Polygon",
        "esri/geometry/Point",
        "esri/geometry/geometryEngine",
      ]);
      let NGeo;
      if (Geometria.type === "point") {
        const nP = proj4.transform(
          proj4.Proj("EPSG:3857"),
          proj4.Proj("EPSG:4326"),
          [Geometria.x, Geometria.y]
        );
        NGeo = new Point({
          x: nP.x,
          y: nP.y,
          spatialReference: { wkid: 4326 },
          type: "point",
        });
      }
      if (Geometria.type === "polyline") {
        let phatsT = [];
        Geometria.paths.forEach((ItPath) => {
          let phatsST = [];
          ItPath.forEach((ItSP) => {
            const nP = proj4.transform(
              proj4.Proj("EPSG:3857"),
              proj4.Proj("EPSG:4326"),
              ItSP
            );
            phatsST.push([nP.x, nP.y]);
          });
          phatsT.push(phatsST);
        });
        NGeo = new Polyline({
          hasZ: false,
          hasM: true,
          paths: phatsT,
          spatialReference: { wkid: 4326 },
          type: "polyline",
        });
      }
      if (Geometria.type === "polygon") {
        let Cring = [];
        Geometria.rings.forEach((ring) => {
          let ringT = [];
          ring.forEach((ItSP) => {
            const nP = proj4.transform(
              proj4.Proj("EPSG:3857"),
              proj4.Proj("EPSG:4326"),
              ItSP
            );
            ringT.push([nP.x, nP.y]);
          });
          Cring.push(ringT);
        });
        NGeo = new Polygon({
          hasZ: false,
          hasM: true,
          rings: Cring,
          spatialReference: { wkid: 4326 },
          type: "polyline",
        });
      }
      let valido = geometryEngine.intersects(
        this.AreaTrabajo[0].geometry,
        NGeo
      );
      if (valido) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      throw error;
    }
  }
}
